import { useState, useEffect } from 'react'
import Layout from '../../../../components/vision/Layout'
import ProtectedRoute from '../../../../components/vision/ProtectedRoute'

function TabelaIndicadores({ indicadores, formatarValor, formatarData, corHeader, titulo }: {
  indicadores: any[]
  formatarValor: (ind: any) => string
  formatarData: (d: string) => string
  corHeader: string
  titulo: string
}) {
  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className={`bg-gradient-to-r ${corHeader} text-white`}>
            <tr>
              <th className="px-6 py-4 text-left text-sm font-semibold">Indicador</th>
              <th className="px-6 py-4 text-left text-sm font-semibold">Tipo</th>
              <th className="px-6 py-4 text-right text-sm font-semibold">Valor Calculado</th>
              <th className="px-6 py-4 text-left text-sm font-semibold">Valores de Origem</th>
              <th className="px-6 py-4 text-left text-sm font-semibold">Data do Cálculo</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {indicadores.map((ind: any, index: number) => (
              <tr key={ind.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                <td className="px-6 py-4">
                  <div className="font-medium text-gray-900">{ind.nome}</div>
                </td>
                <td className="px-6 py-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    ind.tipo === 'monetario' ? 'bg-green-100 text-green-800' :
                    ind.tipo === 'percentual' ? 'bg-blue-100 text-blue-800' :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {ind.tipo === 'monetario' ? 'Monetário' :
                     ind.tipo === 'percentual' ? 'Percentual' : 'Numérico'}
                  </span>
                </td>
                <td className="px-6 py-4 text-right">
                  <span className="font-bold text-lg text-gray-900">{formatarValor(ind)}</span>
                </td>
                <td className="px-6 py-4">
                  {ind.valores_origem && (
                    <pre className="bg-gray-100 p-2 rounded text-xs overflow-x-auto">
                      {JSON.stringify(ind.valores_origem, null, 2)}
                    </pre>
                  )}
                </td>
                <td className="px-6 py-4 text-sm text-gray-600">{formatarData(ind.data_calculo)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="bg-gray-50 px-6 py-4 border-t-2 border-gray-200 flex items-center justify-between">
        <span className="text-sm font-medium text-gray-700">{titulo} — total:</span>
        <span className="text-lg font-bold text-blue-600">{indicadores.length}</span>
      </div>
    </div>
  )
}

function TabelaIndicadoresSemanais({ indicadores, formatarValor, formatarData, semanaAtual, competencia, calcularDatasSemanais }: {
  indicadores: any[]
  formatarValor: (ind: any) => string
  formatarData: (d: string) => string
  semanaAtual: number
  competencia: string
  calcularDatasSemanais: (c: string, s: number) => { data_inicio: string, data_fim: string }
}) {
  const { data_inicio, data_fim } = calcularDatasSemanais(competencia, semanaAtual)
  const fmt = (d: string) => new Date(d + 'T00:00:00').toLocaleDateString('pt-BR')

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden">
      <div className="px-6 py-4 bg-gradient-to-r from-orange-500 to-red-500 text-white flex items-center justify-between">
        <span className="font-bold text-lg">Semana {semanaAtual} — {fmt(data_inicio)} a {fmt(data_fim)}</span>
        <span className="text-sm opacity-90">{indicadores.filter(i => !i.dados_incompletos).length} calculados</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="px-6 py-3 text-left text-sm font-semibold">Indicador</th>
              <th className="px-6 py-3 text-left text-sm font-semibold">Tipo</th>
              <th className="px-6 py-3 text-right text-sm font-semibold">Valor Calculado</th>
              <th className="px-6 py-3 text-left text-sm font-semibold">Valores de Origem</th>
              <th className="px-6 py-3 text-left text-sm font-semibold">Data do Cálculo</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-200">
            {indicadores.map((ind: any, index: number) => (
              <tr key={ind.id} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                <td className="px-6 py-4">
                  <div className="font-medium text-gray-900">{ind.nome}</div>
                </td>
                <td className="px-6 py-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-medium ${
                    ind.tipo === 'monetario' ? 'bg-green-100 text-green-800' :
                    ind.tipo === 'percentual' ? 'bg-blue-100 text-blue-800' :
                    'bg-gray-100 text-gray-800'
                  }`}>
                    {ind.tipo === 'monetario' ? 'Monetário' :
                     ind.tipo === 'percentual' ? 'Percentual' : 'Numérico'}
                  </span>
                </td>
                <td className="px-6 py-4 text-right">
                  {ind.dados_incompletos ? (
                    <span className="text-gray-400 text-sm italic">— dados insuficientes</span>
                  ) : (
                    <span className="font-bold text-lg text-gray-900">{formatarValor(ind)}</span>
                  )}
                </td>
                <td className="px-6 py-4">
                  {ind.valores_origem && (
                    <pre className="bg-gray-100 p-2 rounded text-xs overflow-x-auto">
                      {JSON.stringify(ind.valores_origem, null, 2)}
                    </pre>
                  )}
                </td>
                <td className="px-6 py-4 text-sm text-gray-600">{formatarData(ind.data_calculo)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default function IndicadoresCalculadosPage() {
  const [clientes, setClientes] = useState<any[]>([])
  const [selectedCliente, setSelectedCliente] = useState<any>(null)
  const [competencia, setCompetencia] = useState<string>('')
  const [loading, setLoading] = useState(false)
  const [indicadoresCalculados, setIndicadoresCalculados] = useState<any[]>([])
  const [indicadoresSemanais, setIndicadoresSemanais] = useState<any[]>([])
  const [planejamentoId, setPlanejamentoId] = useState<string>('')
  const [recalculando, setRecalculando] = useState(false)
  const [recalculandoSemanal, setRecalculandoSemanal] = useState(false)
  const [mensagem, setMensagem] = useState<{ tipo: 'success' | 'error', texto: string } | null>(null)
  const [searchTerm, setSearchTerm] = useState('')
  const [showClientesList, setShowClientesList] = useState(false)
  const [modoCalculo, setModoCalculo] = useState<'mensal' | 'semanal'>('mensal')
  const [semanaAtual, setSemanaAtual] = useState<number>(1)

  useEffect(() => {
    fetchClientes()
    // Definir competência como mês atual
    const hoje = new Date()
    const mesAtual = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}`
    setCompetencia(mesAtual)
  }, [])

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement
      if (!target.closest('.cliente-search-container')) {
        setShowClientesList(false)
      }
    }

    if (showClientesList) {
      document.addEventListener('mousedown', handleClickOutside)
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [showClientesList])

  useEffect(() => {
    if (modoCalculo === 'semanal' && planejamentoId) {
      fetchIndicadoresCalculadosSemanal(planejamentoId, semanaAtual)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planejamentoId, semanaAtual, modoCalculo])

  const clientesFiltrados = clientes.filter(cliente => {
    const nome = (cliente.nome_empresa || cliente.nome_completo || '').toLowerCase()
    return nome.includes(searchTerm.toLowerCase())
  })

  const fetchClientes = async () => {
    try {
      const res = await fetch('/api/gestao/clientes')
      if (res.ok) {
        const response = await res.json()
        const clientesData = response.data || response
        setClientes(Array.isArray(clientesData) ? clientesData : [])
      }
    } catch (error) {
      console.error('Erro ao buscar clientes:', error)
      setClientes([])
    }
  }

  const calcularDatasSemanais = (mesCompetencia: string, numeroSemana: number) => {
    const [ano, mes] = mesCompetencia.split('-')
    const primeiroDiaDoMes = new Date(parseInt(ano), parseInt(mes) - 1, 1)
    const diasOffset = (numeroSemana - 1) * 7
    const dataInicio = new Date(primeiroDiaDoMes)
    dataInicio.setDate(dataInicio.getDate() + diasOffset)
    const dataFim = new Date(dataInicio)
    dataFim.setDate(dataFim.getDate() + 6)
    const ultimoDiaDoMes = new Date(parseInt(ano), parseInt(mes), 0)
    if (dataFim > ultimoDiaDoMes) dataFim.setTime(ultimoDiaDoMes.getTime())
    return {
      data_inicio: dataInicio.toISOString().split('T')[0],
      data_fim: dataFim.toISOString().split('T')[0]
    }
  }

  const calcularNumeroSemanas = (mesCompetencia: string) => {
    const [ano, mes] = mesCompetencia.split('-')
    const ultimoDiaDoMes = new Date(parseInt(ano), parseInt(mes), 0).getDate()
    return Math.ceil(ultimoDiaDoMes / 7)
  }

  const fetchIndicadoresCalculados = async () => {
    if (!selectedCliente || !competencia) return

    setLoading(true)
    setMensagem(null)
    
    try {
      // Buscar planejamento do cliente para o mês
      const resPlan = await fetch(`/api/gestao/kpis/planejamento?cliente_id=${selectedCliente.id}&mes_competencia=${competencia}-01`)
      
      if (!resPlan.ok) {
        setMensagem({ tipo: 'error', texto: 'Planejamento não encontrado para este mês' })
        setIndicadoresCalculados([])
        setPlanejamentoId('')
        setLoading(false)
        return
      }

      const planejamentoData = await resPlan.json()
      
      // Garantir compatibilidade com array ou objeto (API sempre retorna array agora)
      const planejamentoArray = Array.isArray(planejamentoData) ? planejamentoData : (planejamentoData ? [planejamentoData] : [])
      
      if (planejamentoArray.length === 0) {
        setMensagem({ tipo: 'error', texto: 'Nenhum planejamento encontrado para este mês. Faça lançamentos primeiro.' })
        setIndicadoresCalculados([])
        setPlanejamentoId('')
        setLoading(false)
        return
      }

      const planejamento = planejamentoArray[0]
      setPlanejamentoId(planejamento.id)

      // Buscar indicadores calculados
      const res = await fetch(`/api/gestao/kpis/indicadores-calculados?planejamento_id=${planejamento.id}`)
      
      if (res.ok) {
        const dados = await res.json()
        setIndicadoresCalculados(dados.indicadores || [])
        
        if (!dados.indicadores || dados.indicadores.length === 0) {
          setMensagem({ tipo: 'error', texto: 'Nenhum indicador calculado encontrado. Clique em "Recalcular Todos" para gerar.' })
        }
      } else {
        const erro = await res.json()
        setMensagem({ tipo: 'error', texto: `Erro ao buscar indicadores: ${erro.error || 'Erro desconhecido'}` })
        setIndicadoresCalculados([])
      }
    } catch (error) {
      console.error('Erro ao buscar indicadores:', error)
      setMensagem({ tipo: 'error', texto: 'Erro ao buscar indicadores calculados: ' + (error instanceof Error ? error.message : 'Erro desconhecido') })
      setIndicadoresCalculados([])
      setPlanejamentoId('')
    }
    
    setLoading(false)
  }

  const handleRecalcular = async () => {
    if (!planejamentoId) {
      setMensagem({ tipo: 'error', texto: 'Selecione um cliente e mês primeiro' })
      return
    }

    setRecalculando(true)
    setMensagem(null)

    try {
      const res = await fetch('/api/gestao/kpis/calcular-indicadores', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ planejamento_id: planejamentoId })
      })

      if (res.ok) {
        const resultado = await res.json()
        setMensagem({ 
          tipo: 'success', 
          texto: `✅ ${resultado.calculados} indicadores recalculados com sucesso!` 
        })
        
        // Recarregar lista
        await fetchIndicadoresCalculados()
      } else {
        const erro = await res.json()
        setMensagem({ tipo: 'error', texto: `Erro: ${erro.error || 'Falha ao recalcular'}` })
      }
    } catch (error) {
      console.error('Erro ao recalcular:', error)
      setMensagem({ tipo: 'error', texto: 'Erro ao recalcular indicadores' })
    }

    setRecalculando(false)
  }

  const fetchIndicadoresCalculadosSemanal = async (planId: string, semana: number) => {
    if (!planId) return
    setLoading(true)
    setMensagem(null)
    try {
      const res = await fetch(`/api/gestao/kpis/indicadores-calculados-semanal?planejamento_id=${planId}&semana_numero=${semana}`)
      if (res.ok) {
        const dados = await res.json()
        setIndicadoresSemanais(dados.indicadores || [])
        if (!dados.indicadores || dados.indicadores.length === 0) {
          setMensagem({ tipo: 'error', texto: 'Nenhum indicador calculado para esta semana. Clique em "Calcular Semana" para gerar.' })
        }
      } else {
        const erro = await res.json()
        setMensagem({ tipo: 'error', texto: `Erro: ${erro.error || 'Erro desconhecido'}` })
        setIndicadoresSemanais([])
      }
    } catch (error) {
      console.error('Erro ao buscar indicadores semanais:', error)
      setIndicadoresSemanais([])
    }
    setLoading(false)
  }

  const handleRecalcularSemanal = async () => {
    if (!planejamentoId || !competencia) {
      setMensagem({ tipo: 'error', texto: 'Selecione um cliente e mês primeiro' })
      return
    }
    setRecalculandoSemanal(true)
    setMensagem(null)
    const { data_inicio, data_fim } = calcularDatasSemanais(competencia, semanaAtual)
    try {
      const res = await fetch('/api/gestao/kpis/calcular-indicadores-semanal', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ planejamento_id: planejamentoId, semana_numero: semanaAtual, data_inicio, data_fim })
      })
      if (res.ok) {
        const resultado = await res.json()
        setMensagem({
          tipo: 'success',
          texto: `✅ ${resultado.calculados} indicadores calculados para a Semana ${semanaAtual}! ${resultado.sem_dados > 0 ? `(${resultado.sem_dados} sem dados suficientes)` : ''}`
        })
        await fetchIndicadoresCalculadosSemanal(planejamentoId, semanaAtual)
      } else {
        const erro = await res.json()
        setMensagem({ tipo: 'error', texto: `Erro: ${erro.error || 'Falha ao calcular'}` })
      }
    } catch (error) {
      console.error('Erro ao calcular semana:', error)
      setMensagem({ tipo: 'error', texto: 'Erro ao calcular indicadores semanais' })
    }
    setRecalculandoSemanal(false)
  }

  const formatarValor = (indicador: any) => {
    const valor = parseFloat(indicador.valor_calculado)
    
    if (indicador.tipo === 'monetario') {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(valor)
    } else if (indicador.tipo === 'percentual') {
      return `${valor.toFixed(2)}%`
    } else if (indicador.tipo === 'taxa') {
      return valor.toFixed(2)
    } else {
      return valor.toFixed(2)
    }
  }

  const formatarData = (data: string) => {
    return new Date(data).toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    })
  }

  return (
    <ProtectedRoute>
      <Layout>
        <div className="p-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-800 mb-2">Gestão de Indicadores Calculados</h1>
            <p className="text-gray-600">Visualize e recalcule indicadores salvos no banco de dados</p>
          </div>

          {/* Filtros */}
          <div className="bg-white rounded-xl shadow-lg p-6 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              {/* Seletor de Cliente */}
              <div className="cliente-search-container relative">
                <label className="block text-sm font-medium text-gray-700 mb-2">Cliente</label>
                <div className="relative">
                  <input
                    type="text"
                    value={selectedCliente ? (selectedCliente.nome_empresa || selectedCliente.nome_completo) : searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value)
                      setShowClientesList(true)
                      if (!e.target.value) {
                        setSelectedCliente(null)
                        setIndicadoresCalculados([])
                        setPlanejamentoId('')
                      }
                    }}
                    onFocus={() => setShowClientesList(true)}
                    placeholder="Buscar cliente..."
                    className="w-full px-4 py-2 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                  <svg className="absolute right-3 top-3 w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                
                {showClientesList && clientesFiltrados.length > 0 && (
                  <div className="absolute z-50 w-full mt-1 bg-white border-2 border-gray-200 rounded-lg shadow-xl max-h-60 overflow-y-auto">
                    {clientesFiltrados.map(cliente => (
                      <button
                        key={cliente.id}
                        onClick={() => {
                          setSelectedCliente(cliente)
                          setSearchTerm('')
                          setShowClientesList(false)
                          setIndicadoresCalculados([])
                          setPlanejamentoId('')
                        }}
                        className="w-full text-left px-4 py-3 hover:bg-blue-50 transition-colors border-b border-gray-100 last:border-b-0"
                      >
                        <div className="font-medium text-gray-900">
                          {cliente.nome_empresa || cliente.nome_completo}
                        </div>
                      </button>
                    ))}
                  </div>
                )}
              </div>

              {/* Seletor de Mês */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Mês/Ano</label>
                <input
                  type="month"
                  value={competencia}
                  onChange={(e) => {
                    setCompetencia(e.target.value)
                    setIndicadoresCalculados([])
                    setPlanejamentoId('')
                  }}
                  className="w-full px-4 py-2 border-2 border-gray-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {/* Botão Buscar */}
              <div className="flex items-end">
                <button
                  onClick={fetchIndicadoresCalculados}
                  disabled={!selectedCliente || !competencia || loading}
                  className="w-full px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-300 disabled:cursor-not-allowed transition-colors font-medium"
                >
                  {loading ? 'Buscando...' : 'Buscar Indicadores'}
                </button>
              </div>
            </div>

            {/* Toggle Modo de Cálculo */}
            {competencia && (
              <div className="mt-5 pt-5 border-t border-gray-100">
                <label className="block text-sm font-semibold text-gray-700 mb-3">Modo de Visualização</label>
                <div className="flex gap-3">
                  <button
                    onClick={() => { setModoCalculo('mensal'); setIndicadoresSemanais([]) }}
                    className={`flex-1 px-4 py-3 rounded-xl font-semibold transition-all ${
                      modoCalculo === 'mensal'
                        ? 'bg-gradient-to-r from-blue-600 to-indigo-600 text-white shadow-lg'
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                    }`}
                  >
                    <div className="flex items-center justify-center gap-2">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      Mensal
                    </div>
                  </button>
                  <button
                    onClick={() => { setModoCalculo('semanal'); setSemanaAtual(1) }}
                    className={`flex-1 px-4 py-3 rounded-xl font-semibold transition-all ${
                      modoCalculo === 'semanal'
                        ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-lg'
                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                    }`}
                  >
                    <div className="flex items-center justify-center gap-2">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                      </svg>
                      Semanal
                    </div>
                  </button>
                </div>

                {/* Seletor de Semana */}
                {modoCalculo === 'semanal' && (
                  <div className="mt-4">
                    <label className="block text-sm font-semibold text-gray-700 mb-3">Selecione a Semana</label>
                    <div className="grid grid-cols-5 gap-2">
                      {Array.from({ length: calcularNumeroSemanas(competencia) }, (_, i) => i + 1).map(semana => {
                        const { data_inicio, data_fim } = calcularDatasSemanais(competencia, semana)
                        return (
                          <button
                            key={semana}
                            onClick={() => {
                              setSemanaAtual(semana)
                              setMensagem(null)
                              if (planejamentoId) fetchIndicadoresCalculadosSemanal(planejamentoId, semana)
                            }}
                            className={`px-3 py-2 rounded-xl font-semibold text-sm transition-all ${
                              semanaAtual === semana
                                ? 'bg-gradient-to-r from-orange-500 to-red-500 text-white shadow-lg'
                                : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                            }`}
                          >
                            <div>S{semana}</div>
                            <div className="text-xs mt-0.5 opacity-90">
                              {new Date(data_inicio + 'T00:00:00').toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' })}
                            </div>
                          </button>
                        )
                      })}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>

          {/* Mensagem de Feedback */}
          {mensagem && (
            <div className={`mb-6 p-4 rounded-lg ${
              mensagem.tipo === 'success' ? 'bg-green-50 border-2 border-green-200 text-green-800' : 'bg-red-50 border-2 border-red-200 text-red-800'
            }`}>
              {mensagem.texto}
            </div>
          )}

          {/* Ações */}
          {planejamentoId && (
            <div className={`rounded-xl shadow-lg p-6 mb-6 border-2 ${
              modoCalculo === 'mensal'
                ? 'bg-gradient-to-r from-blue-50 to-indigo-50 border-blue-200'
                : 'bg-gradient-to-r from-orange-50 to-red-50 border-orange-200'
            }`}>
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-lg font-bold text-gray-800 mb-1">
                    {modoCalculo === 'mensal' ? 'Recalcular Indicadores Mensais' : `Calcular Indicadores — Semana ${semanaAtual}`}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {modoCalculo === 'mensal'
                      ? 'Recalcula com base na soma de todos os lançamentos do mês'
                      : (() => { const { data_inicio, data_fim } = calcularDatasSemanais(competencia, semanaAtual); return `Calcula com base nos lançamentos reais de ${new Date(data_inicio + 'T00:00:00').toLocaleDateString('pt-BR')} a ${new Date(data_fim + 'T00:00:00').toLocaleDateString('pt-BR')}` })()}
                  </p>
                </div>
                {modoCalculo === 'mensal' ? (
                  <button
                    onClick={handleRecalcular}
                    disabled={recalculando}
                    className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors font-medium flex items-center gap-2"
                  >
                    <svg className={`w-5 h-5 ${recalculando ? 'animate-spin' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    {recalculando ? 'Recalculando...' : 'Recalcular Todos'}
                  </button>
                ) : (
                  <button
                    onClick={handleRecalcularSemanal}
                    disabled={recalculandoSemanal}
                    className="px-6 py-3 bg-orange-500 text-white rounded-lg hover:bg-orange-600 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors font-medium flex items-center gap-2"
                  >
                    <svg className={`w-5 h-5 ${recalculandoSemanal ? 'animate-spin' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                    </svg>
                    {recalculandoSemanal ? 'Calculando...' : `Calcular Semana ${semanaAtual}`}
                  </button>
                )}
              </div>
            </div>
          )}

          {/* Tabela Mensal */}
          {modoCalculo === 'mensal' && (
            indicadoresCalculados.length > 0 ? (
              <TabelaIndicadores
                indicadores={indicadoresCalculados}
                formatarValor={formatarValor}
                formatarData={formatarData}
                corHeader="from-blue-600 to-indigo-600"
                titulo="Indicadores Mensais"
              />
            ) : planejamentoId && !loading ? (
              <div className="bg-yellow-50 border-2 border-yellow-200 rounded-xl p-8 text-center">
                <p className="text-gray-600">Nenhum indicador calculado. Clique em "Recalcular Todos" para gerar.</p>
              </div>
            ) : !selectedCliente || !competencia ? (
              <div className="bg-gray-50 border-2 border-gray-200 rounded-xl p-8 text-center">
                <h3 className="text-lg font-bold text-gray-800 mb-2">Selecione um cliente e mês</h3>
                <p className="text-gray-600">Escolha um cliente e o mês de competência para visualizar os indicadores calculados</p>
              </div>
            ) : null
          )}

          {/* Tabela Semanal */}
          {modoCalculo === 'semanal' && (
            indicadoresSemanais.length > 0 ? (
              <TabelaIndicadoresSemanais
                indicadores={indicadoresSemanais}
                formatarValor={formatarValor}
                formatarData={formatarData}
                semanaAtual={semanaAtual}
                competencia={competencia}
                calcularDatasSemanais={calcularDatasSemanais}
              />
            ) : planejamentoId && !loading ? (
              <div className="bg-orange-50 border-2 border-orange-200 rounded-xl p-8 text-center">
                <p className="text-gray-600">Nenhum cálculo para esta semana. Clique em "Calcular Semana {semanaAtual}" para gerar.</p>
              </div>
            ) : !selectedCliente || !competencia ? (
              <div className="bg-gray-50 border-2 border-gray-200 rounded-xl p-8 text-center">
                <h3 className="text-lg font-bold text-gray-800 mb-2">Selecione um cliente e mês</h3>
                <p className="text-gray-600">Escolha um cliente, o mês e selecione a semana desejada</p>
              </div>
            ) : null
          )}
        </div>
      </Layout>
    </ProtectedRoute>
  )
}
